import { FC } from "react";
import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { LocalAgent } from "../hooks/useLocalAgents";

interface LocalAgentListItemProps {
  agent: LocalAgent;
  isSelected: boolean;
  onSelect: (agentId: string) => void;
}

export const LocalAgentListItem: FC<LocalAgentListItemProps> = ({
  agent,
  isSelected,
  onSelect,
}) => (
  <div
    role="button"
    tabIndex={0}
    onClick={() => onSelect(agent.id)}
    onKeyDown={e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelect(agent.id);
      }
    }}
    aria-label={`View details for ${agent.name}`}
    className={`al-p-3 al-rounded-md al-cursor-pointer al-transition-colors al-border-2 ${
      isSelected
        ? "al-bg-blue-50 al-border-blue-400"
        : "al-bg-white al-border-gray-200 hover:al-bg-gray-50 hover:al-border-gray-300"
    }`}
  >
    <Stack direction="row" justify="between" align="start">
      <div className="al-flex-1">
        <Typography variant="body" weight="medium" className="al-mb-1">
          {agent.name}
        </Typography>
        <Typography className="al-text-gray-600 al-line-clamp-2">{agent.description}</Typography>
        <Typography className="al-text-blue-600 al-mt-1">
          {agent.source_type === "langfuse" ? "Local (edited from Langfuse)" : "Local"} •{" "}
          {agent.model}
        </Typography>
      </div>
    </Stack>
  </div>
);
